<script lang="ts" setup>
import type { NavLink } from '#core/types'

const basePath = computed(() => getProjectPath('/token-settings'))

const nav = computed<NavLink[]>(() => [
  {
    label: 'General Token Settings',
    to: basePath.value,
  },
  {
    label: 'Universal Token Rating',
    to: `${basePath.value}/universal-token-rating`,
  },
  {
    label: 'Teammates',
    to: `${basePath.value}/teammates`,
  },
])
</script>

<template>
  <div data-layout="token-settings">
    <NuxtLoadingIndicator />
    <NuxtLayout name="dashboard" container-layout="fluid">
      <template #sidebar>
        <div class="h-full w-sidebar border-r border-default max-md:hidden">
          <div class="border-b border-default px-2 py-4">
            <TokenSettingsNav
              :items="nav"
              class="text-xs"
              data-testid="token-settings-nav"
            />
          </div>
        </div>
      </template>

      <template #app-footer>
        <CoreAppFooterBlock />
      </template>

      <CoreMobileNav :items="nav" label="Settings">
        <TokenSettingsNav :items="nav" class="text-sm" />
      </CoreMobileNav>

      <slot />
    </NuxtLayout>
  </div>
</template>
